/**
 * EMZI NEXUS — Standardized Status Constants
 * Single source of truth for submission and video statuses
 */

// Submission statuses
export const SUBMISSION_STATUS = {
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CHANGES_REQUESTED: 'changes_requested'
};

// Video statuses
export const VIDEO_STATUS = {
  PENDING_UPLOAD: 'pending_upload',
  PENDING_REVIEW: 'pending_review',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Status color mapping for UI rendering
export const STATUS_COLORS = {
  // Submission statuses
  pending_approval: { bg: '#FFF3CD', text: '#856404', border: '#FFECB5', label: 'Pending Approval', dot: '#F59E0B' },
  approved: { bg: '#D1E7DD', text: '#0F5132', border: '#BADBCC', label: 'Approved', dot: '#10B981' },
  rejected: { bg: '#F8D7DA', text: '#842029', border: '#F5C2C7', label: 'Rejected', dot: '#EF4444' },
  changes_requested: { bg: '#E2E3E5', text: '#41464B', border: '#D3D6D8', label: 'Changes Requested', dot: '#6B7280' },

  // Video statuses
  pending_upload: { bg: '#E8F4FF', text: '#0E67A2', border: '#C4DFFF', label: 'Awaiting Video', dot: '#3B82F6' },
  pending_review: { bg: '#FFF5E6', text: '#9A6700', border: '#FFE4B5', label: 'Video Pending Review', dot: '#F89B29' },
  video_approved: { bg: '#D1FAE5', text: '#065F46', border: '#A7F3D0', label: 'Video Approved', dot: '#059669' },
  video_rejected: { bg: '#FEE2E2', text: '#991B1B', border: '#FECACA', label: 'Video Rejected', dot: '#DC2626' },

  // General
  draft: { bg: '#F3F4F6', text: '#6B7280', border: '#E5E7EB', label: 'Draft', dot: '#9CA3AF' },
  submitted: { bg: '#DBEAFE', text: '#1E40AF', border: '#BFDBFE', label: 'Submitted', dot: '#3B82F6' },
  production_complete: { bg: '#ECFDF5', text: '#047857', border: '#A7F3D0', label: 'Production Complete', dot: '#10B981' }
};

/**
 * Get color config for a given status
 */
export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.draft;
};

/**
 * Render a status badge style object
 */
export const getStatusBadgeStyle = (status) => {
  const c = getStatusColor(status);
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 600,
    background: c.bg,
    color: c.text,
    border: `1px solid ${c.border}`
  };
};
